import React, { } from "react";
import { Modal, Box, Typography, Stack, Button } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { projectDetailsActions } from "../../../store/index";
import { deleteProject } from "../../../services/collectionServices";
import { useNavigate, useParams } from "react-router-dom";

const DeleteProjectModal = () => {
    const dispatch = useDispatch();
    const deleteProjectModal = useSelector((state) => state.projectDetails.deleteProjectModal);
    const theme = useTheme();
    const navigate = useNavigate();
    let params = useParams();
    const project_id = params.project_id;
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: theme.palette.surface1.main,
        color: theme.palette.surface1.contrastText,
        boxShadow: 24,
        p: 4,
        borderRadius: '5px'
    };

    const deleteProjectHandler = async () => {
        try {
            dispatch(projectDetailsActions.setLoader({ value: true }));
            await deleteProject(project_id);
            dispatch(projectDetailsActions.setLoader({ value: false }));
            dispatch(projectDetailsActions.setSnackbar({ value: { open: true, type: 'success', message: 'Project Deleted !!!' } }));
            dispatch(projectDetailsActions.setDeleteProjectModalClose());
            navigate('/collections');
        }
        catch (error) {
            dispatch(projectDetailsActions.setLoader({ value: false }));
            console.log(error.response);
            dispatch(projectDetailsActions.setSnackbar({ value: { open: true, type: 'error', message: error?.response?.statusText || error.toString() } }));
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={deleteProjectModal}
            onClose={() => dispatch(projectDetailsActions.setDeleteProjectModalClose())}
        >
            <Box sx={style}>
                <Stack rowGap={3}>
                    <Typography variant="h5">Delete Project?</Typography>
                    <Typography>This will hide the project from dropdown, but data will not be wiped.</Typography>
                    <Stack direction="row" justifyContent="flex-end" columnGap={3}>
                        <Button onClick={() => dispatch(projectDetailsActions.setDeleteProjectModalClose())}>Cancel</Button>
                        <Button onClick={deleteProjectHandler}>Yes, Delete</Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
}

export default DeleteProjectModal;